import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import { fetchDataSub } from "./redux/datasub/datasubActions";

import * as s from "./styles/globalStyles";
import styled from "styled-components";
// import { AudioPlayer } from "./AudioPlayer";
import Header from "./components/Header";
import About from "./components/About";
import Roadmap from "./components/Roadmap";
import Member from "./components/Member";
import Faq from "./components/Faq";
import Partners from "./components/Partners";
import Footer from "./components/Footer";
import CircleTextLogoLeft from "./components/CircleTextLogoLeft";
import CircleTextLogoRight from "./components/CircleTextLogoRight";
import useMedia from "use-media";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const MintTitle = styled.p`
  color: white;
  font-size: 30px;
  font-family: DelaGothicOne;
  font-weight: 500;
  line-height: 1.6;
`;

export const StyledInput = styled.input`
  color: #777;
  font-size: 2rem;
  border-radius: 5px;
  padding: 0.6rem 0.6rem;
  width: 50%;
  position: relative;
  overflow: hidden;
`;

export const StyledButton = styled.button`
  color: #fff;
  font-size: 2rem;
  font-family: DelaGothicOne;
  border-radius: 50px;
  padding: 0.6rem 3rem;
  position: relative;
  overflow: hidden;
  background-color: #ff0000;
  background: linear-gradient(to right, #e66465, #9198e5, #4ed, yellow);
  background-size: 700% 700%;
  animation: gradation 1.7s ease-in infinite;
  :after {
    content: "";
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
    border-top: transparent;
    border-right: transparent;
    transform: rotate(-135deg);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 1.6rem;
    margin: auto;
  }
`;

export const StyledButtonOparator = styled.button`
  color: #fff;
  font-size: 0.8rem;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 0;
  position: relative;
  overflow: hidden;
  width: 20vw;
  background-color: #ff0000;
`;

export const StyledButtonOparatorOff = styled.button`
  color: #fff;
  font-size: 1rem;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 0;
  position: relative;
  overflow: hidden;
  background-color: #333;
  width: 20vw;
  /* background: linear-gradient(to right, #e66465, #9198e5, #4ed, yellow); */
  background-size: 700% 700%;
`;
export const StyledIncDecButton = styled.button`
  font-family: DelaGothicOne;
  padding: 10px;
  border-radius: 2px;
  margin: 0 2px;
  border: solid 1px #333;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 20px;
  font-weight: bold;
  font-size: 15px;
  color: #333;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;
export const StyledButtonControl = styled.button`
  padding: 10px;
  border-radius: 5px;
  border: none;
  background-color: #333;
  padding: 10px;
  font-weight: bold;
  color: white;
  width: 20%;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledButtonReload = styled.button`
  padding: 10px;
  border-radius: 5px;
  border: none;
  background-color: #333;
  padding: 10px;
  font-weight: bold;
  color: white;
  width: 50%;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;
export const StyledButtonA = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: var(--button-bg);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledButtonWl = styled.button`
  color: #fff;
  font-size: 2rem;
  font-family: DelaGothicOne;
  border-radius: 10px;
  padding: 0.6rem 3rem;
  position: relative;
  overflow: hidden;
  background-color: #ff0000;
  background: linear-gradient(to right, #e66465, #9198e5, #4ed, yellow);
  background-size: 700% 700%;
  animation: gradation 1.7s ease-in infinite;
  cursor: pointer;

  :after {
    content: "";
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
    border-top: transparent;
    border-right: transparent;
    transform: rotate(-135deg);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 1.6rem;
    margin: auto;
  }
`;

export const StyledButtonPS = styled.button`
  color: #fff;
  font-size: 2rem;
  font-family: DelaGothicOne;
  border-radius: 50px;
  padding: 0.6rem 3rem;
  position: relative;
  overflow: hidden;
  background-color: #ff0000;
  background: linear-gradient(to right, #e66465, #9198e5, #4ed, yellow);
  background-size: 700% 700%;
  animation: gradation 1.7s ease-in infinite;
  cursor: pointer;

  :after {
    content: "";
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
    border-top: transparent;
    border-right: transparent;
    transform: rotate(-135deg);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 1.6rem;
    margin: auto;
  }
`;

export const StyledButtonUnlock = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: purple;
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  font-family: DelaGothicOne;
  border-radius: 100%;
  border: none;
  background-color: #fff;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  display: none;
  @media (min-width: 900px) {
    width: 250px;
    display: block;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const datasub = useSelector((state) => state.datasub);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(``);
  const [mintAmount, setMintAmount] = useState(1);
  const [mintAmountWl, setmintAmountWl] = useState(1);

  const [minted, setminted] = useState(0);
  const [mintedWL, setmintedWL] = useState(0);
  const [mintedAL, setmintedAL] = useState(0);

  const [canMint, setcanMint] = useState(0);
  const [mintable, setMintable] = useState(0);
  const [wl, setwl] = useState(false);
  const [lang, setlang] = useState(false);
  const [phaseId, setphaseId] = useState(0);

  const [whitelistProof, setwhitelistProof] = useState("");
  const [whitelistValid, setwhitelistValid] = useState(false);

  // const [allowlistProof, setAllowlistProof] = useState(["", "", ""]);
  // const [allowlistValid, setAllowlistValid] = useState([false, false, false]);
  const [allowlistProof0, setAllowlistProof0] = useState("");
  const [allowlistValid0, setAllowlistValid0] = useState(false);
  const [allowlistProof1, setAllowlistProof1] = useState("");
  const [allowlistValid1, setAllowlistValid1] = useState(false);
  const [allowlistProof2, setAllowlistProof2] = useState("");
  const [allowlistValid2, setAllowlistValid2] = useState(false);

  const [wlMaxMintNum, setwlMaxMintNum] = useState(3);
  const isNotSmp = useMedia({ minWidth: "500px" });
  const [langData, setlangData] = useState({
    fail: "Failed,Please try again.",
    chkops: "you minted NSK! check on your Opensea.",
    minting: "Minting NSK....",
    salestartal1_1: "",
    salestartal1_2: "",
    salestartal2: "",
    salestartwl: "",
    salestartpb: "",
    soldout: "Sold Out! thank you!",
    wl: "Presale",
    pb: "Public Sale",
    gasfee: "+gas Fee",
    network: "to get KIZUNA,Please Connect to Ethereum Mainnet.",
    busy: "Busy",
    minted: "minted",
    youhaveal1_1: "You are on the AL list!",
    youhaveal1_2: "You are on the AL list!",
    youhaveal2: "You are on the AL list!",
    youhavewl: "You are on the AL list!",
    youhavenotwl: "You are not have AL.",
    mintwl: "mintWL",
    mintps: "mintPS",
    reload: "reload",
  });

  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1650,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    DISPLAY_COSTWL: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  // const handleClick = (url, filename) => {
  //   alert("読みこむので少々お待ちください。");
  //   axios
  //     .get(url, {
  //       responseType: "blob",
  //     })
  //     .then((res) => {
  //       fileDownload(res.data, filename);
  //     });
  // };

  const claimNFTsAl = (amount, _phaseId) => {
    let cost = CONFIG.WEI_COSTWL;
    console.log("amount::" + String(amount));
    amount = Number(amount);
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * amount); //個数を１に固定0714(ふりっきー)
    let gasMulti = 1;
    // gasMulti = 0.7 * amount;
    // gasMulti += 1;
    let totalGasLimit = String(gasLimit * gasMulti); //個数を1に固定0714(ふりっきー)
    let allowlistProof = "";
    switch (_phaseId) {
      case 0:
        allowlistProof = allowlistProof0;
        break;
      case 1:
        allowlistProof = allowlistProof1;
        break;
      case 2:
        allowlistProof = allowlistProof2;
        break;
      default:
        console.log("not found PhaseID");
    }
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`${CONFIG.NFT_NAME}${langData.minting}`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .allowlistMint(amount, 0, allowlistProof)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
        // maxPriorityFeePerGas: "40000000000",
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback(langData.fail);
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(langData.chkops);
        setClaimingNft(false);
        checkmintedAL();
        // dispatch(fetchData(blockchain.account));
      });
  };

  const setReveal = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit * 2);
    console.log("Cost: ", 0);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .setReveal(11111)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          // `WOW, the ${CONFIG.NFT_NAME} is yours! go visit opensea.io to view it.`
          `正常にリビールされました！openseaでご確認ください。`
        );
        setClaimingNft(false);

        // dispatch(fetchData(blockchain.account));
        dispatch(fetchDataSub(blockchain.account));
      });
  };

  const setALSaleEnable = (flagBool) => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit * 2);
    console.log("Cost: ", 0);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .setAllowlistSaleEnable(flagBool)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        {
          flagBool
            ? setFeedback("正常にALセール開始されました！")
            : setFeedback("正常にALセール停止されました！");
        }
        setClaimingNft(false);
        // dispatch(fetchData(blockchain.account));
        dispatch(fetchDataSub(blockchain.account));
      });
  };

  const setWLSaleEnable = (flagBool) => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit * 2);
    console.log("Cost: ", 0);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`AL1.SALE 開始します ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .setWhitelistSaleEnable(flagBool)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        // console.log(receipt);
        {
          flagBool
            ? setFeedback("正常にAL1セール開始されました！")
            : setFeedback("正常にAL1セール停止されました！");
        }
        setClaimingNft(false);

        // dispatch(fetchData(blockchain.account));
        dispatch(fetchDataSub(blockchain.account));
      });
  };

  const setPhaseId = (_phaseId) => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit * 2);
    console.log("Cost: ", 0);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`PHASEID.${_phaseId} セットします ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .setPhaseIdWithReset(_phaseId)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        // console.log(receipt);
        switch (_phaseId) {
          case 0:
            setFeedback("正常にAL1 2ndセール開始されました！");
            break;
          case 1:
            setFeedback("正常にAL2セール開始されました！");
            break;
          case 2:
            setFeedback("正常にWLセール開始されました！");
            break;
          default:
            console.log("not found PhaseID");
        }

        setClaimingNft(false);
        checkmintedAL();
        checkphaseId();
        // dispatch(fetchData(blockchain.account));
        dispatch(fetchDataSub(blockchain.account));
      });
  };

  const withdraw = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit * 1);
    console.log("Cost: ", 0);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`出金中 ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .withdraw()
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          // `WOW, the ${CONFIG.NFT_NAME} is yours! go visit opensea.io to view it.`
          `正常に出金されました！`
        );
        setClaimingNft(false);

        // dispatch(fetchData(blockchain.account));
        dispatch(fetchDataSub(blockchain.account));
      });
  };

  const changeLang = () => {
    setlang(!lang);
    let langJson = require("./data/jp.json");
    if (lang) {
      langJson = require("./data/en.json");
    }
    setlangData(langJson);
    initData();
  };

  const getAllowlist = (_phaseId) => {
    if (
      blockchain.account !== "" &&
      blockchain.account !== undefined &&
      blockchain.smartContract !== null
    ) {
      let address = blockchain.account.toLowerCase();
      let { MerkleTree } = require("merkletreejs");
      let keccak256 = require("keccak256");

      let allowlist = require("./data/al" + _phaseId + ".json");

      let hashedAddresses = allowlist.map((addr) => keccak256(addr));
      let merkleTree = new MerkleTree(hashedAddresses, keccak256, {
        sortPairs: true,
      });
      let hashedAddress = keccak256(address);
      let proof = merkleTree.getHexProof(hashedAddress);
      let root = merkleTree.getHexRoot();
      // console.log("AL:address/" + address);
      // console.log("AL:hasheBefore/" + address);
      // console.log("AL:hashed/" + hashedAddress);

      blockchain.smartContract.methods
        .isAllowlisted(blockchain.account, _phaseId, proof)
        .call()
        .then((receipt) => {
          // setAllowlistProof(
          //   allowlistProof.map((value, index) =>
          //     index === _phaseId ? proof : value
          //   )
          // );
          // setAllowlistValid(
          //   allowlistValid.map((value, index) =>
          //     index === _phaseId ? receipt : value
          //   )
          // );
          // console.log("AL" + _phaseId + ":proof/" + allowlistProof[_phaseId]);
          // console.log("AL" + _phaseId + ":root/" + root);
          // console.log(
          //   "allowlistValid/" + _phaseId + "/" + allowlistValid[_phaseId]
          // );

          switch (_phaseId) {
            case 0:
              setAllowlistProof0(proof);
              setAllowlistValid0(receipt);
              console.log("AL" + _phaseId + ":proof/" + allowlistProof0);
              break;
            case 1:
              setAllowlistProof1(proof);
              setAllowlistValid1(receipt);
              console.log("AL" + _phaseId + ":proof/" + allowlistProof1);
              break;
            case 2:
              setAllowlistProof2(proof);
              setAllowlistValid2(receipt);
              console.log("AL" + _phaseId + ":proof/" + allowlistProof2);
              break;
            default:
              console.log("not found PhaseID");
          }

          // console.log("al/" + _phaseId + "/" + proof);
          dispatch(fetchData(blockchain.account));
          dispatch(fetchDataSub(blockchain.account));
        });
      console.log("AL" + _phaseId + ":root/" + root);
      // console.log(
      // setAllowlistProof(proof);
      // setAllowlistValid(valid);
    }
  };

  const checkphaseId = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      blockchain.smartContract.methods
        .getPhaseId()
        .call()
        .then((receipt) => {
          setphaseId(receipt);
          dispatch(fetchData(blockchain.account));
        });
    }
  };

  const checkmintedAL = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      blockchain.smartContract.methods
        .alMinted(blockchain.account)
        .call()
        .then((receipt) => {
          setmintedAL(receipt);
          // console.log("mintedAL:::" + receipt);
          dispatch(fetchData(blockchain.account));
        });
    }
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };
  const getDataSub = () => {
    if (
      blockchain.account !== "" &&
      blockchain.account !== undefined &&
      blockchain.smartContract !== null
    ) {
      dispatch(fetchDataSub(blockchain.account));
    }
    // console.dir(datasub);
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  const getReload = () => {
    location.reload();
  };

  const initData = () => {
    getConfig();
    checkmintedAL();
    checkphaseId();
    getAllowlist(0);
    getAllowlist(1);
    getAllowlist(2);
  };

  useEffect(() => {
    getConfig();
    checkmintedAL();
    checkphaseId();
    getAllowlist(0);
    getAllowlist(1);
    getAllowlist(2);
  }, []);

  useEffect(() => {
    getData();
    getDataSub();
    checkmintedAL();
    checkphaseId();
    getAllowlist(0);
    getAllowlist(1);
    getAllowlist(2);
  }, [blockchain.account]);

  return (
    <s.Screen>
      {/* <Header /> */}

      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "rgba(0, 0, 0,0)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.jpeg" : null}
      >
        <ul class="bgtrans">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <MintTitle
          id="mint"
          style={{
            textAlign: "center",
          }}
        >
          {"MINT"}
        </MintTitle>

        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <CircleTextLogoLeft />
            {/* <StyledImg
              alt={"example"}
              src={"/config/images/example.gif"}
              style={{ transform: "scaleX(-1)" }}
            /> */}
          </s.Container>
          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor: "rgba(0,0,0,0.4)",
              padding: 24,
              borderRadius: 24,
              border: "4px var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 20,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
              LANG/言語
            </s.TextTitle>
            <div class="toggle-switch">
              <input
                id="toggleBox"
                class="toggle-input"
                type="checkbox"
                style={{ display: "none" }}
                onChange={(e) => {
                  // e.preventDefault();
                  changeLang();
                }}
              />
              <label for="toggleBox" class="toggle-label" />
            </div>
            <s.TextTitle style={{ textAlign: "center", color: "yellow" }}>
              {langData.salestartal1_1}
            </s.TextTitle>
            <s.TextTitle style={{ textAlign: "center", color: "yellow" }}>
              {langData.salestartal1_2}
            </s.TextTitle>
            <s.TextTitle style={{ textAlign: "center", color: "yellow" }}>
              {langData.salestartal2}
            </s.TextTitle>
            <s.TextTitle style={{ textAlign: "center", color: "yellow" }}>
              {langData.salestartwl}
            </s.TextTitle>
            {/* <s.TextTitle style={{ textAlign: "center", color: "yellow" }}>
              {langData.salestartpb}
            </s.TextTitle>
 */}
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 20,
                fontWeight: "bold",
                fontFamily: "DelaGothicOne",
                color: "var(--accent-text)",
              }}
            >
              {/* <s.SpacerXSmall />
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                      <AudioPlayer></AudioPlayer>
                </s.TextDescription> */}
              {data.totalSupply}
            </s.TextTitle>
            <s.TextDescription
              style={{
                textAlign: "center",
                fontFamily: "DelaGothicOne",
                color: "var(--primary-text)",
              }}
            >
              <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
              </StyledLink>
            </s.TextDescription>
            <s.SpacerSmall />
            <s.TextTitle
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                fontFamily: "DelaGothicOne",
              }}
            >
              1 {CONFIG.SYMBOL} costs
            </s.TextTitle>
            <s.SpacerXSmall />

            <s.TextTitle
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                fontFamily: "DelaGothicOne",
              }}
            >
              {/* {langData.wl}
                  {" / "} */}
              {CONFIG.DISPLAY_COSTWL}
              {CONFIG.NETWORK.SYMBOL}
              {/* {`(Max ${datasub.maxMintsPerWL}mint)`} */}
            </s.TextTitle>
            {/* <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  {langData.pb}
                  {" / "}
                  {CONFIG.DISPLAY_COST}
                  {CONFIG.NETWORK.SYMBOL}
                  {`(Max ${datasub.maxMintsPerPS}mint)`}
                </s.TextTitle> */}
            <s.SpacerXSmall />

            <s.TextDescription
              style={{ textAlign: "center", color: "var(--accent-text)" }}
            >
              {langData.gasfee}
            </s.TextDescription>
            {blockchain.account === "" || blockchain.smartContract === null ? (
              <s.Container ai={"center"} jc={"center"}>
                <s.TextDescription
                  style={{
                    textAlign: "center",
                    color: "var(--accent-text)",
                  }}
                >
                  {langData.network}
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledButton
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(connect(lang));
                    getData();
                  }}
                >
                  CONNECT
                </StyledButton>
                {blockchain.errorMsg !== "" ? (
                  <>
                    <s.SpacerSmall />
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {blockchain.errorMsg}
                    </s.TextDescription>
                  </>
                ) : null}
              </s.Container>
            ) : (
              <>
                <s.TextDescription
                  style={{
                    textAlign: "center",
                    color: "var(--accent-text)",
                  }}
                >
                  {feedback}
                </s.TextDescription>
                <s.Container>
                  <s.Container>
                    {/* AL1 2nd以降ここから */}
                    {allowlistValid0 || allowlistValid1 || allowlistValid2 ? ( //AL1 2nd以降リスト所有確認
                      <>
                        {/* AL1 2nd リスト所持者 */}
                        {allowlistValid0 ? (
                          <s.Container ai={"center"} jc={"center"} fd={"row"}>
                            <s.TextDescription
                              style={{
                                color: "var(--accent-text)",
                                fontFamily: "DelaGothicOne",
                                fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                              }}
                            >
                              {langData.youhaveal1_2 +
                                "(max:" +
                                datasub.maxMintsPerAL_0 +
                                ")"}
                            </s.TextDescription>
                          </s.Container>
                        ) : (
                          <></>
                        )}
                        {/* AL2 リスト所持者 */}
                        {allowlistValid1 ? (
                          <s.Container ai={"center"} jc={"center"} fd={"row"}>
                            <s.TextDescription
                              style={{
                                color: "var(--accent-text)",
                                fontFamily: "DelaGothicOne",
                                fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                              }}
                            >
                              {langData.youhaveal2 +
                                "(max:" +
                                datasub.maxMintsPerAL_1 +
                                ")"}
                            </s.TextDescription>
                          </s.Container>
                        ) : (
                          <></>
                        )}

                        {/* WL リスト所持者 */}
                        {allowlistValid2 ? (
                          <s.Container ai={"center"} jc={"center"} fd={"row"}>
                            <s.TextDescription
                              style={{
                                color: "var(--accent-text)",
                                fontFamily: "DelaGothicOne",
                                fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                              }}
                            >
                              {langData.youhavewl +
                                "(max:" +
                                datasub.maxMintsPerAL_2 +
                                ")"}
                            </s.TextDescription>
                          </s.Container>
                        ) : (
                          <></>
                        )}

                        {/* 所持者メッセージ確認ここまで */}

                        {data.isAlEnabled ? ( //ALセール開始確認
                          <>
                            {/* AL1 2nd ここから */}
                            {phaseId == 0 && allowlistValid0 ? (
                              <>
                                <s.Container
                                  ai={"center"}
                                  jc={"center"}
                                  fd={"row"}
                                >
                                  <s.TextDescription
                                    style={{
                                      color: "var(--accent-text)",
                                      fontFamily: "DelaGothicOne",
                                      fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                                    }}
                                  >
                                    {"AL Now On Sale!"}
                                  </s.TextDescription>
                                </s.Container>
                                {mintedAL == datasub.maxMintsPerAL_0 ? (
                                  <>
                                    <s.Container
                                      ai={"center"}
                                      jc={"center"}
                                      fd={"row"}
                                    >
                                      <StyledButtonWl
                                        disabled={1} //claimingNftPsがtrueなら disabledを表示させる。＝クリックできない
                                        onClick={(e) => {
                                          e.preventDefault();
                                        }}
                                      >
                                        {langData.minted}
                                      </StyledButtonWl>
                                    </s.Container>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {datasub.maxMintsPerAL_0 - mintedAL > 0 ? (
                                  <>
                                    <s.Container
                                      ai={"center"}
                                      jc={"center"}
                                      fd={"row"}
                                    >
                                      <StyledButtonWl
                                        disabled={claimingNft ? 1 : 0} //claimingNftPsがtrueなら disabledを表示させる。＝クリックできない
                                        onClick={(e) => {
                                          e.preventDefault();
                                          claimNFTsAl(1, 0);
                                          getData();
                                        }}
                                      >
                                        {claimingNft ? langData.busy : "1 Mint"}
                                      </StyledButtonWl>
                                    </s.Container>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                            {/* AL1 2nd ここまで */}
                            {/* AL2 ここから */}
                            {phaseId == 1 && allowlistValid1 ? (
                              <>
                                <s.Container
                                  ai={"center"}
                                  jc={"center"}
                                  fd={"row"}
                                >
                                  <s.TextDescription
                                    style={{
                                      color: "var(--accent-text)",
                                      fontFamily: "DelaGothicOne",
                                      fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                                    }}
                                  >
                                    {"AL2 Now On Sale!"}
                                  </s.TextDescription>
                                </s.Container>
                                {mintedAL == datasub.maxMintsPerAL_1 ? (
                                  <>
                                    <s.Container
                                      ai={"center"}
                                      jc={"center"}
                                      fd={"row"}
                                    >
                                      <StyledButtonWl
                                        disabled={1} //claimingNftPsがtrueなら disabledを表示させる。＝クリックできない
                                        onClick={(e) => {
                                          e.preventDefault();
                                        }}
                                      >
                                        {langData.minted}
                                      </StyledButtonWl>
                                    </s.Container>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {datasub.maxMintsPerAL_1 - mintedAL > 0 ? (
                                  <>
                                    <s.Container
                                      ai={"center"}
                                      jc={"center"}
                                      fd={"row"}
                                    >
                                      <StyledButtonWl
                                        disabled={claimingNft ? 1 : 0} //claimingNftPsがtrueなら disabledを表示させる。＝クリックできない
                                        onClick={(e) => {
                                          e.preventDefault();
                                          claimNFTsAl(1, 1);
                                          getData();
                                        }}
                                      >
                                        {claimingNft ? langData.busy : "1 Mint"}
                                      </StyledButtonWl>
                                    </s.Container>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                            {/* AL2 ここまで */}
                            {/* WL ここから */}
                            {phaseId == 2 && allowlistValid2 ? (
                              <>
                                <s.Container
                                  ai={"center"}
                                  jc={"center"}
                                  fd={"row"}
                                >
                                  <s.TextDescription
                                    style={{
                                      color: "var(--accent-text)",
                                      fontFamily: "DelaGothicOne",
                                      fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                                    }}
                                  >
                                    {"WL Now On Sale!"}
                                  </s.TextDescription>
                                </s.Container>
                                {mintedAL == datasub.maxMintsPerAL_2 ? (
                                  <>
                                    <s.Container
                                      ai={"center"}
                                      jc={"center"}
                                      fd={"row"}
                                    >
                                      <StyledButtonWl
                                        disabled={1} //claimingNftPsがtrueなら disabledを表示させる。＝クリックできない
                                        onClick={(e) => {
                                          e.preventDefault();
                                        }}
                                      >
                                        {langData.minted}
                                      </StyledButtonWl>
                                    </s.Container>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {datasub.maxMintsPerAL_2 - mintedAL > 0 ? (
                                  <>
                                    <s.Container
                                      ai={"center"}
                                      jc={"center"}
                                      fd={"row"}
                                    >
                                      <StyledButtonWl
                                        disabled={claimingNft ? 1 : 0} //claimingNftPsがtrueなら disabledを表示させる。＝クリックできない
                                        onClick={(e) => {
                                          e.preventDefault();
                                          claimNFTsAl(1, 2);
                                          getData();
                                        }}
                                      >
                                        {claimingNft ? langData.busy : "1 Mint"}
                                      </StyledButtonWl>
                                    </s.Container>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                            {/* WL ここまで */}
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <>
                        {/* <s.Container ai={"center"} jc={"center"} fd={"row"}>
                              <s.TextDescription
                                style={{
                                  color: "var(--accent-text)",
                                  fontFamily: "DelaGothicOne",
                                  fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                                }}
                              >
                                {langData.youhavenotwl}
                              </s.TextDescription>
                            </s.Container> */}
                      </>
                    )}
                    {/* WLここまで */}
                    {/* AWL保有してない方 */}
                    {allowlistValid0 ||
                    allowlistValid1 ||
                    allowlistValid2 ||
                    whitelistValid ? (
                      <></>
                    ) : (
                      <>
                        {" "}
                        <s.Container ai={"center"} jc={"center"} fd={"row"}>
                          <s.TextDescription
                            style={{
                              color: "var(--accent-text)",
                              fontFamily: "DelaGothicOne",
                              fontSize: isNotSmp ? "1.5rem" : "1.1rem",
                            }}
                          >
                            {langData.youhavenotwl}
                          </s.TextDescription>
                        </s.Container>
                      </>
                    )}
                    {/* AWL保有してない方 */}
                  </s.Container>
                </s.Container>
                <s.SpacerLarge />

                <StyledButtonReload
                  onClick={(e) => {
                    e.preventDefault();
                    getReload();
                  }}
                >
                  {claimingNft ? "Busy" : langData.reload}
                </StyledButtonReload>
              </>
            )}
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <CircleTextLogoRight />
            {/* <StyledImg
              alt={"example"}
              src={"/config/images/example.gif"}
              style={{ transform: "scaleX(-1)" }}
            /> */}
          </s.Container>
        </ResponsiveWrapper>
      </s.Container>
      {/* <About id="about" /> */}
      {/* <Roadmap id="roadmap" /> */}
      {/* <Member id="member" /> */}

      {/* オペレーターコマンド */}
      {blockchain.account === "" ||
      blockchain.smartContract === null ||
      blockchain.account === undefined ? (
        <></>
      ) : (
        <>
          {datasub.deployer == blockchain.account ? (
            <>
              <div
                // ai={"center"}
                style={
                  {
                    // display: "flex",
                    // justifyContent: "center",
                  }
                }
              >
                {!data.isWlEnabled ? (
                  <StyledButtonOparator
                    onClick={(e) => {
                      e.preventDefault();
                      setWLSaleEnable(true);
                      getData();
                    }}
                  >
                    {claimingNft ? "Busy" : "WL.Start"}
                  </StyledButtonOparator>
                ) : (
                  <>
                    <StyledButtonOparatorOff
                      onClick={(e) => {
                        e.preventDefault();
                        setWLSaleEnable(false);
                        getData();
                      }}
                    >
                      {claimingNft ? "Busy" : "WL.Stop"}
                    </StyledButtonOparatorOff>
                  </>
                )}

                {!data.isAlEnabled ? (
                  <StyledButtonOparator
                    onClick={(e) => {
                      e.preventDefault();
                      setALSaleEnable(true);
                      getData();
                    }}
                  >
                    {claimingNft ? "Busy" : "AL.Start"}
                  </StyledButtonOparator>
                ) : (
                  <>
                    <StyledButtonOparatorOff
                      onClick={(e) => {
                        e.preventDefault();
                        setALSaleEnable(false);
                        getData();
                      }}
                    >
                      {claimingNft ? "Busy" : "AL.Stop"}
                    </StyledButtonOparatorOff>
                    {/* AL開放中の場合フェーズIDが切り替えられる */}

                    {/* フェーズIDセット 0 */}
                    {phaseId != 0 ? (
                      <>
                        <StyledButtonOparator
                          onClick={(e) => {
                            e.preventDefault();
                            setPhaseId(0);
                            getData();
                          }}
                        >
                          {claimingNft ? "Busy" : "AL1.2nd"}
                        </StyledButtonOparator>
                      </>
                    ) : (
                      <>
                        <StyledButtonOparatorOff
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                          disabled={1}
                        >
                          {claimingNft ? "Busy" : "NOW.AL1.2nd"}
                        </StyledButtonOparatorOff>
                      </>
                    )}
                    {/* フェーズIDセット 1 */}
                    {phaseId != 1 ? (
                      <>
                        <StyledButtonOparator
                          onClick={(e) => {
                            e.preventDefault();
                            setPhaseId(1);
                            getData();
                          }}
                        >
                          {claimingNft ? "Busy" : "AL2"}
                        </StyledButtonOparator>
                      </>
                    ) : (
                      <>
                        <StyledButtonOparatorOff
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                          disabled={1}
                        >
                          {claimingNft ? "Busy" : "NOW.AL2"}
                        </StyledButtonOparatorOff>
                      </>
                    )}

                    {/* フェーズIDセット 2 */}
                    {phaseId != 2 ? (
                      <>
                        <StyledButtonOparator
                          onClick={(e) => {
                            e.preventDefault();
                            setPhaseId(2);
                            getData();
                          }}
                        >
                          {claimingNft ? "Busy" : "WL"}
                        </StyledButtonOparator>
                      </>
                    ) : (
                      <>
                        <StyledButtonOparatorOff
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                          disabled={1}
                        >
                          {claimingNft ? "Busy" : "NOW.WL"}
                        </StyledButtonOparatorOff>
                      </>
                    )}
                    {/* AL開放中の場合フェーズIDが切り替えられる */}
                  </>
                )}

                <StyledButtonOparator
                  onClick={(e) => {
                    e.preventDefault();
                    setBaseUrl();
                    getData();
                  }}
                >
                  {claimingNft ? "Busy" : "URL.Set"}
                </StyledButtonOparator>

                <StyledButtonOparator
                  onClick={(e) => {
                    e.preventDefault();
                    setReveal();
                    getData();
                  }}
                >
                  {claimingNft ? "Busy" : "REVEAL"}
                </StyledButtonOparator>

                <StyledButtonOparator
                  onClick={(e) => {
                    e.preventDefault();
                    withdraw();
                    getData();
                  }}
                >
                  {claimingNft ? "Busy" : "WITHDRAW"}
                </StyledButtonOparator>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      )}
      {/* オペレーターコマンド */}

      {/* <Faq id="faq" /> */}
      {/* <Partners id="partners" /> */}
      <Footer config={CONFIG} />
    </s.Screen>
  );
}

export default App;
